import { Address } from '../types/bookingTypes'
import { pickupTimesList } from './enums.util'

export function formatPhoneNumber(phoneNumber: string | undefined) {
  if (!phoneNumber) {
    return ''
  }

  const numericPhone = phoneNumber.replace(/\D/g, '')
  return `(${numericPhone.slice(0, 3)}) ${numericPhone.slice(3, 6)}-${numericPhone.slice(6, 10)}`
}

export function formatDate(date: string | Date) {
  return new Date(date).toISOString()
}

// TODO: address format
export function formatAddress(address: Address) {
  return `${address.streetAddress}, ${address.city}, ${address.province}, ${address.postalCode}, ${address.country}`
}
